import styled from 'styled-components';
import { colors, fontFamilySize, px } from '../../../../../../contrib/ui';

export const PlayerInfoStyled = styled.div`
  padding-bottom: ${px(15)};

  .grid {
    .grid-item {
      &.name {
        display: flex;

        flex-direction: row;
        align-items: center;

        .enrollment-avatar {
          width: ${px(100)};
          height: ${px(100)};
          margin-left: ${px(20)};
          margin-right: ${px(10)};
        }

        .player-name {
          p {
            ${fontFamilySize('Heavy', 30)}
            margin-top:0;
            margin-bottom: ${px(5)};
          }
        }
      }

      &.handicaps {
        display: flex;

        flex-direction: column;
        align-items: flex-start;

        p {
          ${fontFamilySize('Heavy', 16)};
          margin-bottom: ${px(5)};

          span {
            padding-left: ${px(15)};
          }
        }

        &.TBD {
          p {
            span {
              color: ${colors.grey9b};
            }
          }
        }
      }
    }
  }
`;
